import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function PieChart({ data }) {
  const chartData = {
    labels: ["Won", "Lost", "Active"],
    datasets: [
      {
        label: "Bids",
        data: [data.won, data.lost, data.active],
        backgroundColor: ["#4CAF50", "#F44336", "#FFC107"],
      },
    ],
  };

  return (
    <div className="chartCard pieChart">
        <h3>Bid Outcome</h3>
        <div className="pieChartContainer">
            <Pie data={chartData} />
        </div>
    </div>

  );
}
